import { render, staticRenderFns } from "./ProfileBranches.vue?vue&type=template&id=52832572&scoped=true&"
import script from "./ProfileBranches.vue?vue&type=script&lang=js&"
export * from "./ProfileBranches.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBranches.vue?vue&type=style&index=0&id=52832572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52832572",
  null
  
)

export default component.exports